import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@gsa/afp-component-library';

const DefaultQuantityAlert = ({ originalLines }) => {
  const defualtedSINs = originalLines.filter(
    (item) => item.estimatedQty === 1 || item.estimatedFleetQty === 1,
  );

  if (defualtedSINs.length === 0) return null;

  return (
    <Alert type="warning" slim className="margin-bottom-2">
      <span className="text-bold">{defualtedSINs.length}</span> Standard Items
      are added with default quantities. Please review the newly added items and
      update the quantities.
    </Alert>
  );
};

DefaultQuantityAlert.propTypes = {
  originalLines: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DefaultQuantityAlert;
